// insurance-modals.js
// Layer 2 — opens/closes layer-2 dialog modals via [data-insurance-modal-open="<id>"]
// and [data-insurance-modal-close]. Native <dialog> handles focus trap and ESC dismissal.

(() => {
  if (window.__insuranceModalsInit) return;
  window.__insuranceModalsInit = true;

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-insurance-modal-open]');
    if (opener) {
      event.preventDefault();
      const id = opener.getAttribute('data-insurance-modal-open');
      const dialog = document.getElementById(id);
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
      }
      return;
    }

    const closer = event.target.closest('[data-insurance-modal-close]');
    if (closer) {
      event.preventDefault();
      const dialog = closer.closest('dialog');
      if (dialog && dialog.open) dialog.close();
    }
  });
})();
